import { defineStore } from 'pinia';
import { ref } from 'vue';

import type { SeenByUserDTO } from '@nora-monorepo/nora-api-client';
import { useApiStore } from '@nora-monorepo/ui-shared';

export const useSeenByModalStore = defineStore('seenByModalStore', () => {
  const isLoading = ref(true);
  const seenByUsers = ref<SeenByUserDTO[]>([]);
  const api = useApiStore();

  const messageId = ref<string | null>(null);
  const conversationId = ref<string | null>(null);
  const isOpen = ref(false);

  async function openModal(
    selectedMessageId: string,
    selectedConversationId: string,
  ): Promise<void> {
    isLoading.value = true;

    isOpen.value = true;
    messageId.value = selectedMessageId;
    conversationId.value = selectedConversationId;

    const result = await api.unwrap(
      api.conversationMessage.getMessageSeenBy({
        messageId: messageId.value,
        conversationId: conversationId.value,
      }),
    );

    isLoading.value = false;
    if (!result.data) {
      seenByUsers.value = [];
      return;
    }

    seenByUsers.value = result.data;
  }

  function reset(): void {
    isLoading.value = false;
    seenByUsers.value = [];

    messageId.value = null;
    conversationId.value = null;
    isOpen.value = false;
  }

  return {
    isLoading,
    seenByUsers,
    isOpen,

    openModal,
    reset,
  };
});
